function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#1E1E1E;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#C60C30;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "path24",
  className: "st0",
  d: "M204.3,3.3h7.8l4.6,21.8l1.3,9l1.5-9l5.4-21.8h6.9l5.7,21.8 l1.5,8.6l1.2-8.6l4.2-21.8h7.8l-9.7,37.5h-8L229.3,20l-1.2-8l-1.1,8l-5.3,20.7h-7.4L204.3,3.3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path26",
  className: "st0",
  d: "M256.6,12.6h7.6v28.2h-7.6V12.6z M260.4,9 c-0.6,0-1.2-0.1-1.8-0.3c-0.5-0.2-1-0.5-1.4-0.9C256.4,7,256,6,256,4.8s0.5-2.3,1.5-3.2s2.1-1.3,3.4-1.3s2.4,0.4,3.2,1.2 c0.8,0.7,1.2,1.7,1.2,3s-0.5,2.3-1.4,3.2C262.8,8.5,261.7,9,260.4,9"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path28",
  className: "st0",
  d: "M272.7,12.6h6.9l0.1,3.3c1.8-1.3,4-2.3,6.5-2.9 c1-0.2,2.1-0.4,3.2-0.4c1.2,0,2.2,0.2,3.3,0.5c1,0.3,1.9,0.9,2.6,1.8c1.4,1.7,2.1,4.5,2.1,8.5v17.4h-7.6V25.1 c0-2.3-0.3-3.9-0.9-4.8c-0.6-0.8-1.6-1.3-3.1-1.3c-1.4,0-2.8,0.4-4.3,1.3c-0.5,0.3-0.9,0.6-1.4,1.1v19.4h-7.6L272.7,12.6"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path30",
  className: "st0",
  d: "M321.6,21.8c0-3-1.6-4.5-4.9-4.5s-4.9,1.5-4.9,4.4 c0,1.3,0.4,2.4,1.2,3.1c0.8,0.8,2,1.1,3.5,1.1c1.6,0,2.7-0.2,3.3-0.6C321,24.6,321.6,23.4,321.6,21.8L321.6,21.8z M312.3,40.8 c-0.7,0.6-1,1.4-1,2.3c0,0.9,0.1,1.7,0.3,2.3c0.2,0.6,0.5,1.2,1,1.6c1,1.1,2.6,1.6,4.7,1.6c4.6,0,6.9-1.3,6.9-4 c0-1.4-0.4-2.4-1.1-2.9c-0.9-0.7-2.6-1-5.2-1h-4C313.3,40.8,312.8,40.8,312.3,40.8L312.3,40.8z M314,30.5c-0.7,0.6-1,1.4-1,2.4 c0,1.2,0.6,1.8,1.8,2c0.4,0.1,0.9,0.1,1.5,0.1h4.6c4.1,0,7,0.9,8.8,2.7c1.3,1.4,2,3.2,2,5.6c0,3.1-1.5,5.6-4.5,7.5 c-2.7,1.7-6,2.5-9.8,2.5c-0.1,0-0.8,0-1.9,0s-2.5-0.2-4.1-0.5c-1.6-0.4-3-0.9-4.1-1.5c-2.3-1.4-3.5-3.3-3.5-5.9 c0-1.9,0.9-3.5,2.6-4.7c0.5-0.4,1.1-0.7,1.7-1c-1.5-0.8-2.3-2.2-2.3-4.4c0-2.6,1.5-4.5,4.4-5.8c-1.8-0.8-3.2-1.8-4.2-3.1 c-1-1.3-1.5-2.8-1.5-4.5c0-6.1,4.2-9.2,12.5-9.2c3.6,0,6.3,0.7,8.3,2c1.2-1.4,2.7-2,4.5-2h3.1v5.9h-4.6c0.3,1,0.5,2.1,0.5,3.4 s-0.3,2.5-0.8,3.6c-0.6,1.1-1.4,2.1-2.4,2.8c-2.2,1.5-5.2,2.3-9.1,2.3C315.6,30.6,314.8,30.6,314,30.5"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path32",
  className: "st0",
  d: "M362.2,21.3c0.1,1,0.1,1.8,0.1,2.5v17h-7.6V25.1 c0-2.3-0.3-3.9-0.8-4.7c-0.5-0.9-1.5-1.3-3-1.3c-1.4,0-2.8,0.4-4.3,1.3c-0.5,0.3-0.9,0.6-1.4,1v19.4h-7.6V12.6h6.9l0.1,3.2 c1.9-1.3,4-2.3,6.5-2.9c1-0.2,2-0.4,3-0.4c3.2,0,5.5,1,6.7,3.1c1.8-1.3,4-2.3,6.5-2.8c0.9-0.2,2-0.3,3.3-0.3s2.4,0.2,3.5,0.5 c1.1,0.4,2,1,2.8,1.8c1.6,1.7,2.4,4.5,2.4,8.4v17.4h-7.6V25c0-2.3-0.2-3.8-0.6-4.5s-0.9-1.1-1.4-1.3c-0.5-0.2-1-0.3-1.4-0.3 s-0.7,0-1,0s-0.7,0.1-1.2,0.2s-1,0.3-1.5,0.5C363.7,20.2,362.9,20.7,362.2,21.3"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path34",
  className: "st0",
  d: "M403,23.1c0-3.4-1.4-5.1-4.2-5.1c-1.5,0-2.7,0.4-3.5,1.3 c-0.9,1-1.5,2.6-1.8,4.8h9.5C403,23.8,403,23.5,403,23.1z M409.1,18.3c0.6,1.4,0.9,3.1,0.9,5.2s-0.1,3.8-0.2,4.9h-16.5 c0.3,4.5,2.8,6.8,7.4,6.8c1.8,0,3.4-0.2,4.7-0.6c1.3-0.4,2.1-0.7,2.5-0.9l1.2,4.3c-1.5,1.3-3.9,2.1-7.2,2.6c-1,0.1-2.4,0.2-4,0.2 s-3.2-0.3-4.8-1c-1.6-0.6-3-1.6-4.1-2.8c-2.3-2.5-3.4-6-3.4-10.5c0-4.1,1.1-7.4,3.4-10c2.4-2.7,5.8-4,10-4 C404.1,12.6,407.4,14.5,409.1,18.3"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path36",
  className: "st0",
  d: "M416.6,12.6h6.9l0.1,3.3c1.8-1.3,4-2.3,6.5-2.9 c1-0.2,2.1-0.4,3.2-0.4c1.2,0,2.2,0.2,3.3,0.5c1,0.3,1.9,0.9,2.6,1.8c1.4,1.7,2.1,4.5,2.1,8.5v17.4h-7.6V25.1 c0-2.3-0.3-3.9-0.9-4.8c-0.6-0.8-1.6-1.3-3.1-1.3c-1.4,0-2.8,0.4-4.3,1.3c-0.5,0.3-0.9,0.6-1.4,1.1v19.4h-7.6L416.6,12.6"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path38",
  className: "st0",
  d: "M211,73.2c0.4,0.6,0.9,1.1,1.5,1.5s1.3,0.5,2.1,0.5 s1.5-0.1,2.1-0.4s1.1-0.7,1.5-1.3c0.9-1.2,1.3-3,1.3-5.4c0-2-0.4-3.6-1.2-4.8c-0.8-1.3-2-1.9-3.5-1.9c-2.4,0-3.9,1.2-4.7,3.7 c-0.3,0.9-0.4,1.9-0.4,3s0.1,2.1,0.3,2.9C210.3,71.8,210.6,72.6,211,73.2z M210.7,77.6c-2.3-1-3.8-2.7-4.7-5.3 c-0.4-1.2-0.6-2.6-0.6-4.2s0.2-3.1,0.8-4.3c0.5-1.3,1.2-2.3,2-3.1c1.7-1.7,4.1-2.5,7-2.5c2.6,0,4.7,0.9,6.3,2.7 c1.5,1.8,2.3,4.2,2.3,7.1c0,3.4-0.9,6-2.7,7.9c-1.7,1.7-3.9,2.5-6.8,2.5C213,78.3,211.8,78.1,210.7,77.6"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path40",
  className: "st0",
  d: "M227.4,63.2h3.7l0.1,1.8c1-0.7,2.1-1.2,3.5-1.6 c0.5-0.1,1.1-0.2,1.7-0.2s1.2,0.1,1.8,0.3s1,0.5,1.4,0.9c0.8,0.9,1.2,2.4,1.2,4.6v9.4h-4.1v-8.5c0-1.2-0.2-2.1-0.5-2.6 s-0.8-0.7-1.7-0.7c-0.7,0-1.5,0.2-2.3,0.7c-0.3,0.2-0.5,0.3-0.7,0.6v10.5h-4.1L227.4,63.2"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path42",
  className: "st0",
  d: "M245.2,78.3h4.1V56.5h-4.1V78.3z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path44",
  className: "st0",
  d: "M254,63.2h4.1v15.2H254V63.2L254,63.2z M256,61.2 c-0.3,0-0.7-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5c-0.5-0.4-0.7-1-0.7-1.6c0-0.7,0.3-1.2,0.8-1.7s1.1-0.7,1.8-0.7 c0.7,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,0.9,0.6,1.6c0,0.7-0.3,1.3-0.8,1.7C257.3,61,256.7,61.2,256,61.2"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path46",
  className: "st0",
  d: "M262.6,63.2h3.7l0.1,1.8c1-0.7,2.1-1.2,3.5-1.6 c0.5-0.1,1.1-0.2,1.7-0.2s1.2,0.1,1.8,0.3c0.6,0.2,1,0.5,1.4,0.9c0.8,0.9,1.2,2.4,1.2,4.6v9.4h-4.1v-8.5c0-1.2-0.2-2.1-0.5-2.6 s-0.8-0.7-1.7-0.7c-0.7,0-1.5,0.2-2.3,0.7c-0.3,0.2-0.5,0.3-0.7,0.6v10.5h-4.1V63.2"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path48",
  className: "st0",
  d: "M288.7,68.8c0-1.8-0.8-2.7-2.3-2.7c-0.8,0-1.4,0.2-1.9,0.7 s-0.8,1.4-1,2.6h5.1C288.6,69.2,288.7,69,288.7,68.8z M291.9,66.2c0.3,0.7,0.5,1.7,0.5,2.8c0,1.1,0,2-0.1,2.6h-8.9 c0.2,2.4,1.5,3.7,4,3.7c1,0,1.8-0.1,2.5-0.3c0.7-0.2,1.1-0.4,1.3-0.5l0.7,2.3c-0.8,0.7-2.1,1.1-3.8,1.4c-0.6,0.1-1.3,0.1-2.1,0.1 c-0.9,0-1.7-0.2-2.6-0.5s-1.6-0.8-2.2-1.5c-1.2-1.3-1.8-3.2-1.8-5.6c0-2.2,0.6-4,1.9-5.4s3.1-2.2,5.4-2.2 C289.2,63.2,291,64.2,291.9,66.2"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path50",
  className: "st0",
  d: "M305.5,58.1h5.9l2.7,10.6l1,4.5l0.8-4.5l2.4-10.6h5.7l2.4,20.2 h-4.1l-1-10.7l-0.4-6.1l-1.5,6l-2.9,10.8h-3.3L310,67.5l-1.5-6l-1.3,16.8h-3.9L305.5,58.1"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path52",
  className: "st0",
  d: "M332.8,73.5c0,0.3,0.1,0.6,0.2,0.9s0.2,0.5,0.4,0.7 c0.4,0.3,0.8,0.5,1.5,0.5s1.4-0.2,2-0.6c0.2-0.1,0.3-0.2,0.3-0.3v-3.6c-1.4,0-2.6,0.3-3.5,0.8C333.1,72.2,332.8,72.8,332.8,73.5z  M337.4,76.9c-1.1,1-2.4,1.5-3.9,1.5s-2.6-0.5-3.5-1.4s-1.3-2.1-1.3-3.5c0-1.7,0.9-3,2.6-3.7c1.3-0.6,3.3-0.9,6-0.9V68 c0-0.7-0.2-1.2-0.5-1.4c-0.4-0.2-1.2-0.3-2.4-0.3c-0.7,0-1.5,0.1-2.4,0.4s-1.4,0.5-1.8,0.6l-0.9-2.5c1-0.6,2.4-1.1,4.2-1.4 c0.6-0.1,1.3-0.2,2.1-0.2c0.8,0,1.6,0.1,2.4,0.2c0.8,0.2,1.4,0.4,1.9,0.8c1,0.8,1.5,2.2,1.5,4.3v9.8H339c-0.6,0-0.9-0.1-1.1-0.2 c-0.3-0.2-0.4-0.6-0.4-1.2v0"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path54",
  className: "st0",
  d: "M352.8,66.9c-1.3,0-2.4,0.5-3.3,1.5v9.9h-4.1V63.2h3.6l0.2,2.2 c0.5-0.9,1.5-1.6,2.9-2c0.4-0.1,0.9-0.2,1.4-0.2s0.9,0,1.1,0v4.3C354.1,67.1,353.5,66.9,352.8,66.9"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path56",
  className: "st0",
  d: "M357.6,56.5h4.1v9l-0.1,3.8l5.1-6.1h4.6l-5.3,6l5.9,9.1h-4.7 l-3.9-6.2l-1.6,1.7l0.1,1.7v2.8h-4.1V56.5"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path58",
  className: "st0",
  d: "M382.2,68.8c0-1.8-0.8-2.7-2.3-2.7c-0.8,0-1.4,0.2-1.9,0.7 s-0.8,1.4-1,2.6h5.1C382.2,69.2,382.2,69,382.2,68.8z M385.5,66.2c0.3,0.7,0.5,1.7,0.5,2.8c0,1.1,0,2-0.1,2.6H377 c0.2,2.4,1.5,3.7,4,3.7c1,0,1.8-0.1,2.5-0.3c0.7-0.2,1.1-0.4,1.3-0.5l0.7,2.3c-0.8,0.7-2.1,1.1-3.8,1.4c-0.6,0.1-1.3,0.1-2.1,0.1 c-0.9,0-1.7-0.2-2.6-0.5s-1.6-0.8-2.2-1.5c-1.2-1.3-1.8-3.2-1.8-5.6c0-2.2,0.6-4,1.9-5.4s3.1-2.2,5.4-2.2 C382.8,63.2,384.6,64.2,385.5,66.2"
}));

var _ref21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path60",
  className: "st0",
  d: "M390.1,66h-1.8v-2.2c0.8-0.3,1.4-0.4,1.6-0.5 c0.4-0.2,0.7-0.5,0.8-0.8c0.3-0.7,0.6-1.6,1-2.7h2.5v3.4h4.1V66h-4.1v6c0,1.4,0.1,2.3,0.4,2.8c0.1,0.2,0.3,0.4,0.5,0.4 c0.2,0.1,0.5,0.1,0.7,0.1s0.5,0,0.7-0.1c0.2,0,0.4-0.1,0.7-0.1c0.5-0.1,0.8-0.3,1.1-0.4l0.5,2.3c-0.7,0.6-1.7,1-3,1.3 c-0.5,0.1-1,0.1-1.6,0.1s-1.2-0.1-1.7-0.3c-0.5-0.2-1-0.4-1.3-0.8c-0.6-0.7-1-1.9-1-3.6L390.1,66"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path62",
  className: "st0",
  d: "M401.6,63.2h4.1v15.2h-4.1V63.2z M403.6,61.2 c-0.3,0-0.7-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5c-0.5-0.4-0.7-1-0.7-1.6c0-0.7,0.3-1.2,0.8-1.7s1.1-0.7,1.8-0.7 c0.7,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,0.9,0.6,1.6c0,0.7-0.3,1.3-0.8,1.7C404.9,61,404.3,61.2,403.6,61.2"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path64",
  className: "st0",
  d: "M410.2,63.2h3.7L414,65c1-0.7,2.1-1.2,3.5-1.6 c0.5-0.1,1.1-0.2,1.7-0.2s1.2,0.1,1.8,0.3c0.6,0.2,1,0.5,1.4,0.9c0.8,0.9,1.2,2.4,1.2,4.6v9.4h-4.1v-8.5c0-1.2-0.2-2.1-0.5-2.6 s-0.8-0.7-1.7-0.7c-0.7,0-1.5,0.2-2.3,0.7c-0.3,0.2-0.5,0.3-0.7,0.6v10.5h-4.1V63.2"
}));

var _ref24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path66",
  className: "st0",
  d: "M436.5,68.1c0-1.6-0.9-2.4-2.6-2.4c-1.8,0-2.6,0.8-2.6,2.4 c0,0.7,0.2,1.3,0.6,1.7c0.4,0.4,1.1,0.6,1.9,0.6c0.9,0,1.5-0.1,1.8-0.3C436.2,69.6,436.5,68.9,436.5,68.1L436.5,68.1z M431.5,78.3 c-0.4,0.3-0.5,0.8-0.5,1.3s0.1,0.9,0.2,1.2c0.1,0.3,0.3,0.6,0.5,0.9c0.6,0.6,1.4,0.9,2.5,0.9c2.5,0,3.7-0.7,3.7-2.1 c0-0.7-0.2-1.3-0.6-1.6c-0.5-0.4-1.4-0.5-2.8-0.5h-2.1C432,78.3,431.8,78.3,431.5,78.3z M432.4,72.8c-0.4,0.3-0.6,0.7-0.6,1.3 c0,0.6,0.3,1,1,1.1c0.2,0,0.5,0,0.8,0h2.5c2.2,0,3.8,0.5,4.7,1.4c0.7,0.7,1,1.7,1,3c0,1.7-0.8,3-2.4,4c-1.5,0.9-3.2,1.3-5.3,1.3 c-0.1,0-0.4,0-1,0s-1.3-0.1-2.2-0.3c-0.9-0.2-1.6-0.5-2.2-0.8c-1.2-0.7-1.9-1.8-1.9-3.2c0-1,0.5-1.9,1.4-2.5 c0.3-0.2,0.6-0.4,0.9-0.5c-0.8-0.4-1.2-1.2-1.2-2.3c0-1.4,0.8-2.4,2.4-3.1c-1-0.4-1.7-1-2.3-1.7c-0.5-0.7-0.8-1.5-0.8-2.4 c0-3.3,2.2-4.9,6.7-4.9c1.9,0,3.4,0.4,4.5,1.1c0.6-0.7,1.4-1.1,2.4-1.1h1.7v3.2H440c0.2,0.5,0.3,1.1,0.3,1.8c0,0.7-0.1,1.3-0.4,2 c-0.3,0.6-0.7,1.1-1.3,1.5c-1.2,0.8-2.8,1.2-4.9,1.2C433.3,72.8,432.8,72.8,432.4,72.8"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "path22",
  className: "st1",
  d: "M85.6,45.4c0,0,37.8,34.2,68.1,33.1c0,0,8.8-3.1,8.8-12.5 C162.5,66,137.5,71,85.6,45.4z M58.3,23.3c2.2,3.8,71.1,43.9,106.7,37.4c0,0,14.4-6.9,14.4-22.8C179.4,37.9,121.6,40.6,58.3,23.3z  M0,0.7c96.9,37.8,179.7,31.9,179.7,31.9s14.1-9.2,14.1-29.4C192.9,3.2,21.9-1.8,0,0.7"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 442.6 85",
    style: {
      enableBackground: "new 0 0 442.6 85"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.064e84e0.svg";
export { ForwardRef as ReactComponent };